import { getEntityRef } from "@client/content/lib/helper";
import { getCurrentUserId } from "@client/lib/cookie";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import { setShowingModal, submitVote } from "../../../actions";
import { localStateSelector } from "../../../selectors";
import { type Leaderboard } from "../../../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: EntityRef): MapProps => {
    const localState = localStateSelector(state, props);

    const vote = localState.vote!;
    return {
      ...props,
      error: vote.error,
      isEditMode: state.isEditMode,
      countryCode: localState.countryCode,
      isSubmitting: vote.status === "Submitting",
      isUserKnown: !!getCurrentUserId(),
      item: vote.item
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: EntityRef): ActionProps => ({
  onClose: () => dispatch(setShowingModal(getEntityRef(props), null)),
  onSubmit: (data: Leaderboard.View.UserData | null) => dispatch(submitVote(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
